module.exports = __webpack_public_path__ + "assets/img/NPC028.86d870d8.png";